"use strict";

var Shipment = require('../Shipment');

var ShipStationOrder = require('./ShipStationOrder');

function createNewShipStationOrder(shipment, orderNumber, options) {
  if (!Object.prototype.isPrototypeOf.call(Shipment.prototype, shipment)) {
    throw new Error('shipment must be an instance of Shipment');
  }

  var order_number = orderNumber || shipment.order_id;

  if (!order_number) {
    throw new Error('Either orderNumber or shipment.order_id is required');
  }

  return ShipStationOrder.makeShipStationOrder(shipment, order_number, options);
}

module.exports = createNewShipStationOrder;